var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "emd-pulse", class: "_color_" + _vm.color }, [
    _c("div", { staticClass: "emd-pulse__item _first" }),
    _c("div", { staticClass: "emd-pulse__item" }),
    _c("div", { staticClass: "emd-pulse__item _pulse" }),
    _c("div", { staticClass: "emd-pulse__item _last" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }